import React from 'react';

import { IconsEnum } from '../../../../../../../assets/icons/types';
import { ProductsListItemEditLinkProduct } from './ProductsListItemEditLink.type';
import { GADataType } from '../../../../../../../types';

import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';
import { NextPureTooltipIconLinkHelper } from '../../../../../../../helpers/links/NextPureTooltipIconLinkHelper';

import { words } from '../../../../../../../locales/keys';
import { ProductPath } from '../../../../../ProductPath';

interface ProductsListItemEditLinkProps {
  product: ProductsListItemEditLinkProduct;
  onMouseEnter?: () => void;
}

function ProductsListItemEditLink({
  dataGa,
  product,
  onMouseEnter
}: ProductsListItemEditLinkProps & GADataType) {
  return (
    <NextPureTooltipIconLinkHelper
      className="bg-white dark:bg-gray-900 dark:hover:bg-gray-700 dark:text-gray-300 focus:ring-offset-0 font-medium hover:bg-gray-200 inline-flex items-center p-1 rounded-md text-gray-700 text-sm pointer-events-auto shadow dark:glow"
      dataGa={dataGa}
      href={ProductPath.edit(product.nanoId)}
      icon={IconsEnum.PENCIL}
      iconClassName="h-5 w-5 stroke-1.75"
      onMouseEnter={onMouseEnter}
      tooltipI18nText={words.edit}
      tooltipPlacement={TooltipPlacement.LEFT}
      tooltipSingleton
    />
  );
}

export default ProductsListItemEditLink;
